import { Admin, CustomRoutes, Resource } from 'react-admin'
import { Route } from 'react-router-dom'
import { authProvider } from './authProvider'
import { dataProvider } from './dataProvider'
import SalesProvider from './concepts/Sales/storage/SalesProvider'
import Layout from './layout/Layout'
import Login from './concepts/Login/views/Login'
import { routesConfig } from './routesConfig'

import SaleList from './concepts/Sales/views/SaleList'
import { SaleShow } from './concepts/Sales/views/SaleShow'
import EarningsList from './concepts/Earnings/views/EarningsList'
import ManageUsers from './concepts/Account/views/ManageUsers'
import usePartnerName from './layout/hooks/usePartnerName'
import AffiliateCreate from './concepts/Affiliates/views/AffiliateCreate'

import { darkTheme, lightTheme } from './theme'

export const App = () => {
  const partnerName = usePartnerName()

  const getLabel = (pageTitle: string, partnerName?: string) => {
    return partnerName ? `${partnerName} / ${pageTitle}` : pageTitle
  }

  return (
    <SalesProvider>
      <Admin
        title="Partners @ StackCommerce"
        dataProvider={dataProvider}
        authProvider={authProvider}
        layout={Layout}
        loginPage={Login}
        darkTheme={darkTheme}
        lightTheme={lightTheme}
      >
        <Resource
          name="sales"
          list={SaleList}
          show={SaleShow}
          options={{ label: getLabel('Sales', partnerName) }}
          recordRepresentation={(record) => `/ ${record.name}`}
        />
        <Resource
          name="earnings/summary"
          list={EarningsList}
          options={{ label: getLabel('Earnings', partnerName) }}
        />
        <Resource
          name="account/manage-users"
          list={ManageUsers}
          options={{
            label: getLabel('Account / Manage Users', partnerName)
          }}
        />
        <Resource name="affiliates" create={AffiliateCreate} />
        <CustomRoutes>
          {routesConfig.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </CustomRoutes>
      </Admin>
    </SalesProvider>
  )
}
